import type { Session, User } from "@supabase/supabase-js";
import { getSupabase } from "./client";

/**
 * Auth de Potencial: Google como proveedor de identidad, gestionado por Supabase Auth
 * (la sesión/JWT la maneja Supabase, no Firebase). Mantiene el UX de "Sign in with Google".
 */
export async function signInWithGoogle(redirectTo?: string): Promise<void> {
  const supabase = getSupabase();
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: redirectTo ?? window.location.origin,
      queryParams: { access_type: "offline", prompt: "consent" },
    },
  });
  if (error) throw error;
}

export async function signOut(): Promise<void> {
  const { error } = await getSupabase().auth.signOut();
  if (error) throw error;
}

export async function getCurrentUser(): Promise<User | null> {
  const { data } = await getSupabase().auth.getUser();
  return data.user ?? null;
}

export function onAuthChange(cb: (session: Session | null) => void): () => void {
  const { data } = getSupabase().auth.onAuthStateChange((_event, session) => cb(session));
  return () => data.subscription.unsubscribe();
}
